var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgListOms(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 13,
    viewBox: "0 0 14 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.33333 -1.52588e-05H0.875C0.391751 -1.52588e-05 0 0.373081 0 0.833318V2.22221C0 2.68244 0.391751 3.05554 0.875 3.05554H2.33333C2.81658 3.05554 3.20833 2.68244 3.20833 2.22221V0.833318C3.20833 0.373081 2.81658 -1.52588e-05 2.33333 -1.52588e-05Z",
    fill: "#811942"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.33333 4.72221H0.875C0.391751 4.72221 0 5.09531 0 5.55555V6.94444C0 7.40467 0.391751 7.77777 0.875 7.77777H2.33333C2.81658 7.77777 3.20833 7.40467 3.20833 6.94444V5.55555C3.20833 5.09531 2.81658 4.72221 2.33333 4.72221Z",
    fill: "#EB4899"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.33333 9.44443H0.875C0.391751 9.44443 0 9.81752 0 10.2778V11.6666C0 12.1269 0.391751 12.5 0.875 12.5H2.33333C2.81658 12.5 3.20833 12.1269 3.20833 11.6666V10.2778C3.20833 9.81752 2.81658 9.44443 2.33333 9.44443Z",
    fill: "#F9A8D3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1252 -1.52588e-05H5.8335C5.35025 -1.52588e-05 4.9585 0.373081 4.9585 0.833318V2.22221C4.9585 2.68244 5.35025 3.05554 5.8335 3.05554H13.1252C13.6084 3.05554 14.0002 2.68244 14.0002 2.22221V0.833318C14.0002 0.373081 13.6084 -1.52588e-05 13.1252 -1.52588e-05Z",
    fill: "#811942"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1252 4.72221H5.8335C5.35025 4.72221 4.9585 5.09531 4.9585 5.55555V6.94444C4.9585 7.40467 5.35025 7.77777 5.8335 7.77777H13.1252C13.6084 7.77777 14.0002 7.40467 14.0002 6.94444V5.55555C14.0002 5.09531 13.6084 4.72221 13.1252 4.72221Z",
    fill: "#EB4899"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1252 9.44444H5.8335C5.35025 9.44444 4.9585 9.81754 4.9585 10.2778V11.6667C4.9585 12.1269 5.35025 12.5 5.8335 12.5H13.1252C13.6084 12.5 14.0002 12.1269 14.0002 11.6667V10.2778C14.0002 9.81754 13.6084 9.44444 13.1252 9.44444Z",
    fill: "#F9A8D3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgListOms);
export default __webpack_public_path__ + "static/media/list-oms.4289dedb04247c9ef0cb4b343dbc869c.svg";
export { ForwardRef as ReactComponent };